/**
 * @description 代客下单
 * @author sunxiaojuan
 */
export default {
    BASE_URL: '',
    api: [
      {
        name: 'getPayMethod',
        desc: '根据项目查询结算方式',
        method: 'GET',
        path: 'tmb/order/getPayMethod'
      },
      {
        name: 'getProjectList',
        desc: '根据客户查询项目',
        method: 'GET',
        path: 'tmb/order/getProjectList'
      },
      {
        name: 'getProjectListOfSelf',
        desc: '自建根据客户查询项目',
        method: 'GET',
        path: 'tmb/order/getProjectListOfSelf'
      },
      {
        name: 'findCrmInfo',
        desc: '查询用户列表',
        method: 'POST',
        path: 'sysCrmMember/findCrmInfoCertPass'
      },
      //自建订单
      {
        name: 'findSelfCrmInfo',
        desc: '选择用户自建客户',
        method: 'POST',
        path: 'sysCrmMember/findSelfCrmInfo'
      },
       //自建订单
      {
        name: 'getProdSkuList',
        desc: '查询商品列表',
        method: 'POST',
        path: 'mm/sheftShop/productManage/getProdSkuList'
      },
      {
        name: 'getProdSkuListV5',
        desc: '查询商品列表',
        method: 'POST',
        path: 'mm/sku/getListByParam'
      },
      {
        name: 'createOrder',
        desc: '后台代客下订提交',
        method: 'POST',
        path: 'tmb/order/createOrder'
      },
      // 自建下单提交
      {
        name: 'createSelfOrder',
        desc: '自建下单提交',
        method: 'POST',
        path: 'tmb/order/createSelfOrder'
      },
      {
        name: 'getFaPiaoList',
        desc: '获取增票机制信息',
        method: 'POST',
        path: 'tmb/order/createOrder'
      },
      // v5.0.1 新增 销售订单
      {
        name: 'submitOrder',
        desc: '订单(自建订单,代客下单合并)-提交',
        method: 'POST',
        path: 'tm/order/submitOrder'
      }
    ]
  }



// WEBPACK FOOTER //
// ./src/api/apis/self/order/replace.js